import { ReactElement } from 'react';
import BackgroundAndIdentityDetails from '@components/FVSPage/BackgroundAndIdentityDetails';
import { fvsInfoDisplayObject } from '@services/FormFieldConfig';

function FVSStep17(): ReactElement {
  return (
    <>
      <BackgroundAndIdentityDetails displayObject={fvsInfoDisplayObject} currentStepNo="step17" />
    </>
  );
}

export default FVSStep17;
